"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var themes_1 = require("../../themes");
var Typo_1 = require("../Typo");
var mixins_1 = require("../../themes/mixins");
var DisplayIcon_1 = require("../../utils/comps/DisplayIcon");
var OKELink_1 = require("../OKELink");
var parseMetaBlockConfig_1 = require("./utils/parseMetaBlockConfig");
var utilsOolib_1 = require("../../utilsOolib");
var greyColor100 = themes_1.colors.greyColor100;
var StyledHorOrientContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  ", "\n"])), function (_a) {
    var align = _a.align;
    return align === "center" && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      justify-content: center;\n    "], ["\n      justify-content: center;\n    "])));
});
var StyledVerOrientContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  ", "\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  ", "\n"])), function (_a) {
    var align = _a.align;
    return align === "center" && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      align-items: center;\n    "], ["\n      align-items: center;\n    "])));
});
var StyledMetaWrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n"])));
var STYLED_SANS_2 = (0, styled_components_1.default)(Typo_1.SANS_2)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n  ", ";\n"], ["\n  ", "\n  ", ";\n"])), mixins_1.ellipsis, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), themes_1.colors.greyColor40);
});
var StyledSeparator = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 0.3rem;\n  height: 0.3rem;\n  border-radius: 50%;\n  background-color: ", ";\n"], ["\n  width: 0.3rem;\n  height: 0.3rem;\n  border-radius: 50%;\n  background-color: ", ";\n"])), function (_a) {
    var disabled = _a.disabled, invert = _a.invert;
    return disabled
        ? themes_1.colors.greyColor40
        : invert
            ? themes_1.colors.white
            : themes_1.colors.greyColor100;
});
var MetaBlock = function (_a) {
    var data = _a.data, config = _a.config, disabled = _a.disabled, _b = _a.align, align = _b === void 0 ? "left" : _b, invert = _a.invert, _c = _a.orientation, orientation = _c === void 0 ? "horizontal" : _c;
    var localize = (0, utilsOolib_1.useLocale)();
    var value = (0, parseMetaBlockConfig_1.parseMetaBlockConfig)({ config: config, data: data, localize: localize });
    if (value.length === 0)
        return null;
    var genText = function (_a) {
        var icon = _a.icon, display = _a.display;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            icon && (react_1.default.createElement(DisplayIcon_1.DisplayIcon, { icon: icon, size: 15, color: invert ? themes_1.colors.white : themes_1.colors.greyColor100, weight: "regular" })),
            react_1.default.createElement(STYLED_SANS_2, { invert: invert, disabled: disabled, capitalize: true }, display)));
    };
    var genLink = function (_a) {
        var icon = _a.icon, display = _a.display, to = _a.to;
        return (react_1.default.createElement(Typo_1.SANS_2, { style: icon ? { marginBottom: "-3.3px" } : {} },
            " ",
            react_1.default.createElement(OKELink_1.OKELink, { to: to, text: display, invert: invert, icon: icon })));
    };
    /**
     * basically we need a max width on each meta item
     * only then the ellipsis would work. So the logic we
     * use for now is, the max width is equally divided between
     * the total number of meta items. However to calc this,
     * we need to minus out the separator/s and flex gap/s
     *
     * Hence this semi complex calculation
     */
    var calcMaxWidthForEachMetaItem_HOR = function (value) {
        var percent = (100 / value.length) + '%';
        var pixelsToMinus = ((value.length - 1) * (2 + 0.3)) + 'rem'; // 2 = flex gap on the 2 sides of the separator, 0.3 = separator width
        var toReturn = "calc(".concat(percent, " - ").concat(pixelsToMinus, ")");
        return toReturn;
    };
    return orientation === "horizontal" ? (react_1.default.createElement(StyledHorOrientContainer, { align: align }, value.map(function (v, i) { return (react_1.default.createElement(react_1.Fragment, { key: i },
        react_1.default.createElement(StyledMetaWrapper, { style: { maxWidth: calcMaxWidthForEachMetaItem_HOR(value) /*100 / value.length + "%"*/ } }, v.to
            ? genLink({ display: v.display, to: v.to, icon: v.icon })
            : genText({ icon: v.icon, display: v.display })),
        i + 1 === value.length ? null : (react_1.default.createElement(StyledSeparator, { invert: invert, disabled: disabled })))); }))) : (react_1.default.createElement(StyledVerOrientContainer, { align: align }, value.map(function (v, i) { return (react_1.default.createElement("div", { style: { maxWidth: "100%" } }, v.to
        ? genLink({ display: v.display, to: v.to, icon: v.icon })
        : genText({ icon: v.icon, display: v.display }))); })));
};
exports.default = MetaBlock;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
